export default __webpack_public_path__ + "static/placeholder-d7110eee737b9285014dcfc4494a491b.webp";